/* eslint-disable */
export const HOME = {
    emergentLink: "home-emergent-link",
};

export const DASHBOARD = {
    container: "dashboard-container",
    header: "dashboard-header",
    headline: "dashboard-headline",
    metricsList: "dashboard-metrics-list",
};

export const METRIC = {
    card: (id) => `metric-card-${id}`,
    chart: (id) => `metric-chart-${id}`,
    percentileScale: (id) => `metric-percentile-${id}`,
    percentileMarker: (id) => `metric-percentile-marker-${id}`,
    interpretation: (id) => `metric-interpretation-${id}`,
    oiTable: (id) => `metric-oi-table-${id}`,
};
